/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Product_item = {
    readonly productPhotos: ReadonlyArray<{
        readonly placeholder: string | null;
        readonly smallPath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly localizedPdpUrl: string | null;
    readonly " $refType": "Product_item";
};
export type Product_item$data = Product_item;
export type Product_item$key = {
    readonly " $data"?: Product_item$data;
    readonly " $fragmentRefs": FragmentRefs<"Product_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Product_item",
  "selections": [
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "placeholder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '270cec36a93197370fe2f8d168cbb28a';
export default node;
